import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Pricing from './components/Pricing';
import Contact from './components/RegistroTaller';
import Footer from './components/Footer';

// Mapeo: id de nicho en Pricing → valor de niche en RegistroTaller
const PRICING_NICHE_TO_FORM = {
  taller:   'automotriz',
  barberia: 'barberia',
};

const LandingPage = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);

  useEffect(() => {
    if (window.lucide) {
      window.lucide.createIcons();
    }
  }, []);

  const handleSelectPlan = (nicheId, planName, price, wompiLink) => {
    setSelectedPlan({
      niche: PRICING_NICHE_TO_FORM[nicheId] || nicheId,
      plan: planName,
      price,
      wompiLink,
    });
  };

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Pricing onSelectPlan={handleSelectPlan} />
        <Contact selectedPlan={selectedPlan} />
      </main>
      <Footer />
    </>
  );
};

export default LandingPage;